class uiHelper {

  public static shorten = (value: string, maxLength: number) => {
    const originalLength = value.length;
    value = value.substring(0, maxLength);
    if (value.length < originalLength) {
      value += `…`;
    }
    return value;
  }

  public static formatPrice = (price: number, language: string, currency: string) => {
    return Intl.NumberFormat(language, {
      style: `currency`,
      currency: currency,
    }).format(price);
  }

}

export default uiHelper;

